// extracted by mini-css-extract-plugin
export default {"root":"Settings_root__kVy3o","tabs":"Settings_tabs__VMDC3","tab":"Settings_tab__kNptZ","tab__active":"Settings_tab__active__mNzf3 Settings_tab__kNptZ","box":"Settings_box__Ci-Qk"};